import { getOfficeType } from "../../../../../actions/Utilities/OfficeType";
import { useQuery } from "react-query";

export default function useOfficeType() {
  //Fetching OfficeType Details
  const {data, isFetching} = useQuery("GetOfficeTypes", getOfficeType, {
    refetchOnWindowFocus: false,
  });
  if(data){
    data.sort((a, b) => {
        let fa = a.officeTypeName.toLowerCase(), fb = b.officeTypeName.toLowerCase();
        return (fa < fb)?-1:(fa > fb?1:0);
    });
  }
  return {data, isFetching};
}
